<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/alert.svg" size="2"></app-svg>

  <h1>{{ duplicates.length }} Duplicate Uploads</h1>
  <p>You are already uploading files with these names. Please wait until the upload is done and then try again.</p>

  <button
    appButton
    name="confirm"
    location="delete-assets-in-uploads-dialog"
    color="primary"
    (click)="close()"
    height="4"
    size="3"
    weight="bold"
    shape="round"
    spacing="full"
  >
    Ok
  </button>
</div>
